// todo: .env kullanmak daha sağlıklı olabilir.
const KIMLIK_USERNAME = 'kimlik';
const KIMLIK_PASSWORD = 'ff147b70-6b7a-482a-82f4-23ecc5186c54';

export { KIMLIK_USERNAME, KIMLIK_PASSWORD };
